import * as types from './types';

const INITIAL_STATE = {
  getVendingMachines: {
    loading: false,
    data: null,
    errors: null,
  },
  postVendingMachine: {
    loading: false,
    data: null,
    errors: null,
  },
  postDeleteVendingMachine: {
    loading: false,
    data: null,
    errors: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.VENDING_GETVENDINGMACHINES_LOADING: {
      const { getVendingMachines } = state;
      return {
        ...state,
        getVendingMachines: { ...getVendingMachines, loading: action.payload },
      };
    }
    case types.VENDING_GETVENDINGMACHINES_SUCCESS: {
      const { getVendingMachines } = state;
      return {
        ...state,
        getVendingMachines: { ...getVendingMachines, data: action.payload },
      };
    }
    case types.VENDING_GETVENDINGMACHINES_ERROR: {
      const { getVendingMachines } = state;
      return {
        ...state,
        getVendingMachines: { ...getVendingMachines, errors: action.payload },
      };
    }

    case types.VENDING_POSTVENDINGMACHINE_LOADING: {
      const { postVendingMachine } = state;
      return {
        ...state,
        postVendingMachine: {
          ...postVendingMachine,
          loading: action.payload,
        },
      };
    }
    case types.VENDING_POSTVENDINGMACHINE_SUCCESS: {
      const { postVendingMachine } = state;
      return {
        ...state,
        postVendingMachine: { ...postVendingMachine, data: action.payload },
      };
    }
    case types.VENDING_POSTVENDINGMACHINE_ERROR: {
      const { postVendingMachine } = state;
      return {
        ...state,
        postVendingMachine: { ...postVendingMachine, errors: action.payload },
      };
    }

    case types.VENDING_POSTDELETEVENDINGMACHINE_LOADING: {
      const { postDeleteVendingMachine } = state;
      return {
        ...state,
        postDeleteVendingMachine: {
          ...postDeleteVendingMachine,
          loading: action.payload,
        },
      };
    }
    case types.VENDING_POSTDELETEVENDINGMACHINE_SUCCESS: {
      const { postDeleteVendingMachine } = state;
      return {
        ...state,
        postDeleteVendingMachine: {
          ...postDeleteVendingMachine,
          data: action.payload,
        },
      };
    }
    case types.VENDING_POSTDELETEVENDINGMACHINE_ERROR: {
      const { postDeleteVendingMachine } = state;
      return {
        ...state,
        postDeleteVendingMachine: {
          ...postDeleteVendingMachine,
          errors: action.payload,
        },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/state/reducer.js